import { h, Fragment } from "preact"

import Link from "components/Link"

const JLINC_TERMS = (
  <Fragment>
    <p>{LEGAL_APP_NAME} provides web software under the Terms below.</p>
    <p>
      <strong>Overview</strong>
    </p>
    <p>
      Tru Social Inc. provides a social media platform where you control your
      own data and attention. Tru does not sell your data, participate in adtech
      targeted advertising, or use algorithms to manipulate your attention for
      advertising. We are committed to protecting your privacy, both in our web
      services and in our communications with you.
    </p>
    <p>
      <strong>Data Use & Custodianship</strong>
    </p>
    <p>
      Upon signing up to create an account at {location.host}, {LEGAL_APP_NAME}{" "}
      shall serve as a personal "Data Custodian" acting on your behalf.
    </p>
    <p>
      {APP_NAME} provides you, the account holder, with an automated interface
      to control and manage digitally signed data sharing agreements with Data
      Custodians representing businesses and other entities using the{" "}
      <Link href="https://www.jlinc.com/" type="link">
        JLINC protocol
      </Link>
      .
    </p>
    <p>
      {APP_NAME} shall take all reasonable precautions to keep your data secure
      and to only transfer your data, permissions, consents and preferences, to
      other parties as directly instructed by you.
    </p>
    <p>
      Signing up on {APP_NAME} represents your affirmative agreement to these
      Terms. The exact language of these Terms may be modified. However, the
      substance of the intent shall not be changed without obtaining affirmative
      permission from you in a clear, simple and understandable manner.
    </p>
    <p>
      {LEGAL_APP_NAME} is a California benefit corporation with both data
      integrity and environmental protection written into its founding articles.
    </p>
    <p>
      <strong>Messaging and Communications</strong>
    </p>
    <p>
      By providing your phone number or other contact information, you consent
      to receive communications from {LEGAL_APP_NAME} via SMS, voice, email, or
      other methods, as permitted by law and in accordance with your
      preferences. Such communications may be sent directly by {LEGAL_APP_NAME}{" "}
      or through third-party service providers such as Twilio. Standard message
      and data rates may apply based on your carrier and plan.
    </p>

    <p>
      <strong>User Consent and Responsibilities</strong>
    </p>
    <p>
      You agree not to use {APP_NAME} to send unsolicited, unauthorized, or
      unlawful messages. All messaging activities must comply with the{" "}
      <a
        href="https://www.twilio.com/legal/messaging-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Twilio Messaging Policy
      </a>{" "}
      and{" "}
      <a
        href="https://www.twilio.com/legal/aup"
        target="_blank"
        rel="noopener noreferrer"
      >
        Acceptable Use Policy
      </a>
      , as well as all applicable laws and regulations regarding consent,
      privacy, and messaging in your local jurisdiction.
    </p>

    <p>
      <strong>Unsubscribing and Opt-Out</strong>
    </p>
    <p>
      Recipients of messages sent via {APP_NAME} must have a clear and simple
      way to opt out or unsubscribe from receiving communications at any time.
      If you receive communications in error or wish to stop receiving them,
      please follow the instructions provided in the message, such as replying
      "STOP" to SMS messages, or contact us directly for assistance.
    </p>

    <p>
      <strong>Compliance with Laws</strong>
    </p>
    <p>
      You are solely responsible for ensuring that your use of messaging
      features through {APP_NAME} complies with all applicable laws and
      regulations, including, but not limited to, the Telephone Consumer
      Protection Act (TCPA), CAN-SPAM Act, and any local data protection
      regulations.
    </p>

    <p>
      <strong>Third-Party Services</strong>
    </p>
    <p>
      {APP_NAME} uses third-party services, including Twilio, to facilitate
      messaging and communications. By using these features, you acknowledge
      that your data may be processed by such third parties in accordance with
      their privacy and security policies. For more details, please refer to{" "}
      <a
        href="https://www.twilio.com/legal/privacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Twilio’s Privacy Policy
      </a>
      .
    </p>
  </Fragment>
)

export default function JlincTerms() {
  return JLINC_TERMS
}
